import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Available, Initiated, Occupied } from "../../constant/Constant";
import { QrCode, Eye, EyeOff, Phone, User } from "lucide-react";
import ClientDetailForm from "./ClientDetailForm";
import ServiceCardList from "./ServiceCardList";

const SeatCard = () => {
    const FloorReducer = useSelector((state) => state.FloorReducer);
    const [blurredQR, setBlurredQR] = useState({}); // Store blur state for each seat

    useEffect(() => {
        // On mount or when FloorReducer changes, set all Initiated seats to blurred by default
        const defaultBlur = {};
        FloorReducer?.doc?.forEach((ele) => {
            if (ele?.status === Initiated) {
                defaultBlur[ele._id] = true;
            }
        });
        setBlurredQR(defaultBlur);
    }, [FloorReducer]);

    const generateQRCodeURL = (data) => {
        const encodedData = encodeURIComponent(data);
        return `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodedData}`;
    };

    const toggleQRBlur = (seatId) => {
        setBlurredQR((prev) => ({
            ...prev,
            [seatId]: !prev[seatId],
        }));
    };

    return (
        FloorReducer?.doc?.map((ele) => {
            if (ele?.status === Initiated) {
                const isBlurred = blurredQR[ele._id];

                return (
                    <div key={ele._id} className="bg-white rounded-lg shadow mb-4">
                        <div className="bg-blue-500 text-white p-2 rounded-t-lg flex justify-between items-center text-sm">
                            <p className="mt-0.5">{ele?.seatCode} ({Initiated})</p>
                            <button onClick={() => toggleQRBlur(ele._id)} className="text-white">
                                {isBlurred ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                            </button>
                        </div>
                        <div className="p-4">
                            <div className="flex flex-col items-center">
                                <div className="relative p-4 bg-white border-2 border-gray-200 rounded-lg shadow-lg mb-4">
                                    <img
                                        src={generateQRCodeURL(ele._id)}
                                        alt={`QR Code for seat ${ele.seatCode}`}
                                        className={`w-32 h-32 transition duration-300 ${isBlurred ? 'blur-md' : ''}`}
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                    <div style={{ display: 'none' }} className="w-32 h-32 flex items-center justify-center bg-gray-100 border rounded absolute top-0 left-0">
                                        <QrCode className="w-16 h-16 text-gray-400" />
                                    </div>
                                    {isBlurred && (
                                        <div className="absolute top-0 left-0 w-full h-full bg-white/50 backdrop-blur-md rounded-lg z-10" />
                                    )}
                                </div>

                                <p className="text-sm text-gray-600 mb-4 text-center">
                                    Scan This QR Code To Activate <br /> {ele?.seatName} Seat For {ele?.seatFor}
                                </p>
                            </div>
                        </div>
                    </div>
                );
            }

            if (ele?.status === Available) {
                return (
                    <div key={ele._id} className="bg-white rounded-lg shadow mb-4">
                        <div className="bg-emerald-500 text-white p-2 rounded-t-lg flex justify-between text-sm">
                            <p className="mt-0.5">{ele?.seatCode} ({Available})</p>
                            <p>Device : {ele?.deviceInfo?.[0]?.deviceName}</p>
                        </div>
                        <div className="p-4">
                            <ClientDetailForm selectedSeat={ele} />
                        </div>
                    </div>
                );
            }

            return (
                <div key={ele._id} className="bg-white rounded-lg shadow mb-4 ">
                    <div className="bg-rose-500 text-white p-2 rounded-t-lg flex justify-between text-sm">
                        <p className="mt-0.5">{ele?.seatCode} ({Occupied})</p>
                        <p>Device : {ele?.deviceInfo?.[0]?.deviceName}</p>
                    </div>
                    <div className="m-4">
                        <p className="text-sm text-rose-500 mb-2">Customer Details :</p>
                        <div className="flex gap-2 shadow-sm p-2 rounded-lg">
                            <div className="flex gap-1">
                                <div className="bg-white">
                                    <User size={'20'} />
                                </div>
                                <p className="text-sm">{ele?.clientInfo?.[0]?.name}</p>
                            </div>
                            <div className="flex gap-1">
                                <Phone size={'18'} />
                                <p className="text-sm">{ele?.clientInfo?.[0]?.phoneNumber}</p>
                            </div>
                        </div>
                    </div>
                    <div className="m-4">
                        <p className="text-sm text-rose-500 mb-2">Service Details :</p>
                        {console.log('ele?.serviceInfo',ele?.serviceInfo)}
                        <ServiceCardList services={ele?.serviceInfo}/>
                    </div>
                </div>
            );
        })
    );
};

export default SeatCard;
